import fetch from '@api/axios';
import userApi from '@api/endpoints/user';
import authApi from '@api/endpoints/auth';
import ordersApi from '@api/endpoints/orders';
import jigneshApi from '@api/endpoints/jignesh';
import searchApi from '@api/endpoints/search';
import referralsApi from '@api/endpoints/referrals';
import nrApi from '@api/endpoints/nrAccount';
import providerHolidays from '@api/endpoints/providerHolidays';
import providerPotBalance from '@api/endpoints/providerPotBalance';
import workflowApi from '@api/endpoints/workflow';
import kycApi from '@api/endpoints/kyc';
import thunesApi from '@api/endpoints/thunes';
import sourceAccountApi from '@api/endpoints/sourceAccount';
import jobsApi from '@api/endpoints/jobs';
import configApi from '@api/endpoints/config';
import referralsV2Api from '@api/endpoints/referrals_v2';
import nreNroApi from '@api/endpoints/nreNro';
import ticketsApi from '@api/endpoints/tickets';
import cxUsers from '@api/endpoints/cxUsers';
import workflowApiV2 from '@api/endpoints/workflowsV2';
import nronboardApi from '@api/endpoints/nrOnboard';
import userSourceAccount from '@api/endpoints/userSourceAccount';
import orderScreenConfigApi from '@api/endpoints/orderScreenConfig';
import platformTransferFee from '@api/endpoints/platformTransferFee';
import uaeManualPayments from '@api/endpoints/uaeManualPayments';
import rda from '@api/endpoints/rda';
import vanceCash from '@api/endpoints/vanceCash';
import vanceCashV2 from '@api/endpoints/vanceCashV2';
import vdaFunnel from '@api/endpoints/vdaFunnel';
import reconDashboard from '@api/endpoints/reconDashboard';
import fxRatePeakingConfig from '@api/endpoints/fxRatePeakingConfig';
import transferExperienceConfig from '@api/endpoints/transferExperienceConfig';
import featureFlags from '@api/endpoints/featureFlags';
import studentProgram from '@api/endpoints/studentProgram';
import manualPayoutBatchApi from '@api/endpoints/manualPayoutBatch';
import accessManagement from '@api/endpoints/accessManagement';
import rewardsApi from '@api/endpoints/rewards';
import baerscrestOps from '@api/endpoints/baerscrest';
import falconTransactionsSearch from '@api/endpoints/b2bDashboard/Falcon';
import rdaDashboard from '@api/endpoints/rdaDashboard';
import falconDashboard from '@api/endpoints/falconDashboard';
import beneficiaryVerifications from '@api/endpoints/beneficiaryVerification';
import rfiApi from '@api/endpoints/rfi';
import cxOperations from '@api/endpoints/cxOperations';
import luluRefundsDashboard from '@api/endpoints/luluRefundsDashboard';
import reconDashboardV2 from '@api/endpoints/reconDashboardV2';
import settlementTimelineManager from '@api/endpoints/settlementTimelineManager';
import settlementServiceDashboard from '@api/endpoints/settlementServiceDashboard';
import rewardsV2Api from '@api/endpoints/rewards_v2';
import bbpsApi from '@api/endpoints/bbps';
import gomsFulfillmentApi from '@api/endpoints/gomsFulfillment';
import caseInvestigationManagerApi from '@api/endpoints/caseInvestigationManager';
import outboundCallingApi from '@api/endpoints/outboundCalling';
import libraDashboard from '@api/endpoints/LibraDashboard';
import fxServiceManager from '@api/endpoints/fxServiceManager';
import fastTransferManager from '@api/endpoints/fastTransferManager';


const api = {
  user: userApi(fetch, '/admin/user'),
  auth: authApi(fetch),
  jignesh: jigneshApi(fetch, '/admin/ask-jignesh'),
  search: searchApi(fetch, '/admin'),
  orders: ordersApi(fetch, '/admin/orders'),
  referrals: referralsApi(fetch, '/referrals/campaign'),
  nrAccount: nrApi(fetch, '/admin/nr-account'),
  providerHolidays: providerHolidays(
    fetch,
    '/admin/config/fulfillment-holiday'
  ),
  providerPotBalance: providerPotBalance(fetch, '/provider-pot-balance'),
  workflow: workflowApi(fetch, '/workflows'),
  userOrders(userId) {
    return ordersApi(fetch, `/admin/user/${userId}/order`);
  },
  kyc: kycApi(fetch, `/admin`),
  thunes: thunesApi(fetch, ''),
  sourceAccounts: sourceAccountApi(fetch, '/source-account'),
  userSourceAccounts: userSourceAccount(fetch, '/admin/leantech'),
  jobs: jobsApi(fetch, '/job'),
  config: configApi(fetch, '/admin/config'),
  referralsV2: referralsV2Api(fetch, '/v2/referrals'),
  nreNro: nreNroApi(fetch, '/nre-nro'),
  tickets: ticketsApi(fetch, '/admin/ops-ticket'),
  cxUsers: cxUsers(fetch, '/admin/alphadesk-user/OPS_ROLE'),
  workflowsV2: workflowApiV2(fetch, '/workflows/v2'),
  nronboard: nronboardApi(fetch, '/nre-nro/onboarding'),
  orderScreenConfig: orderScreenConfigApi(
    fetch,
    '/admin/orders/compliance-flag'
  ),
  platformTransferFees: platformTransferFee(fetch, '/rate-comparator'),
  uaeManualPayments: uaeManualPayments(fetch, '/uae-manual-payments/pending'),
  rda: rda(fetch, '/rda'),
  vanceCash: vanceCash(fetch, '/v4/referrals'),
  vanceCashV2: vanceCashV2(fetch, '/admin/reward-service'),
  vdaFunnel: vdaFunnel(fetch, '/admin/vda'),
  reconDashboard: reconDashboard(fetch, '/recon-dashboard'),
  fxRatePeakingConfig: fxRatePeakingConfig(fetch, '/config/fx-rate-peaking'),
  downtimeConfig: transferExperienceConfig(fetch, '/downtime'),
  featureFlags: featureFlags(fetch, '/admin/feature-flags'),
  studentProgram: studentProgram(fetch, '/student-program'),
  manualPayoutBatch: manualPayoutBatchApi(fetch, '/manual-payouts'),
  accessManagement: accessManagement(fetch, '/access-management'),
  rewards: rewardsApi(fetch, '/admin/rewards'),
  baerscrestOps: baerscrestOps(fetch, '/admin/baerscrest-ops'),
  falconTransactionsSearch: falconTransactionsSearch(
    fetch,
    '/admin/falcon/dashboard'
  ),
  rdaDashboard: rdaDashboard(fetch, '/admin/rda-dashboard'),
  falconDashboard: falconDashboard(fetch, '/api/v1'),
  beneficiaryVerifications: beneficiaryVerifications(
    fetch,
    '/admin/orders/beneficiary/verifications'
  ),
  rfi: rfiApi(fetch, '/admin/rfi'),
  cxTechOperations: cxOperations(fetch, '/cx-tech'),
  luluRefundsDashboard: luluRefundsDashboard(fetch, '/lulu-refund'),
  reconDashboardV2: reconDashboardV2(fetch, '/api/recon'),
  settlementTimelineManager: settlementTimelineManager(
    fetch,
    '/api/v1/timeline-settlement'
  ),
  settlementServiceDashboard: settlementServiceDashboard(fetch, '/api/v1/settlement-service'),
  rewardsV2: rewardsV2Api(fetch, '/admin/reward-service'),
  bbps: bbpsApi(fetch, '/admin/bbps/api/v1'),
  gomsFulfillment: gomsFulfillmentApi(fetch, '/admin/fulfillments/api/v1'),
  caseInvestigationManager: caseInvestigationManagerApi(fetch, '/api/v1/ponzim'),
  outboundCalling: outboundCallingApi(fetch, '/admin/support-outbound-calling/api/v1'),
  libraDashboard: libraDashboard(fetch, '/admin/api/v1'),
  fxServiceManager: fxServiceManager(fetch, '/fx-service-manager'),
  fastTransferManager: fastTransferManager(fetch, '/admin/fast-transfers/config/global-rails')
};

export default api;
